/**
 * Parses a date string in either YYYY-MM-DD or DD/MM/YYYY format into a Date object in the local timezone.
 * This avoids timezone conversion issues associated with parsing date-only ISO strings.
 */
export function parseDate(dateStr: string): Date {
	if (dateStr.includes("-")) {
		// YYYY-MM-DD format (local timezone)
		const [year, month, day] = dateStr.split("-").map(Number);
		return new Date(year, month - 1, day);
	}
	if (dateStr.includes("/")) {
		// DD/MM/YYYY format (local timezone)
		const [day, month, year] = dateStr.split("/").map(Number);
		return new Date(year, month - 1, day);
	}
	return new Date(dateStr);
}
